import ComponentManager from '@/Management/ComponentManager';
import LinkViewModel from '@/ViewModels/Controls/LinkViewModel';
import type LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import type ImageViewModel from '@/ViewModels/Controls/ImageViewModel';
import LabelViewModelBuilder from '@/Builder/LabelViewModelBuilder';
import ImageViewModelBuilder from '@/Builder/ImageViewModelBuilder';
import GlobalConfiguration from '@/Management/GlobalConfiguration';
import type DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';
import { IToolBarLinkViewModelConstructorParameter} from '#/DefaultViewExtensionInterfaces';
import type ToolBarViewModel from '@/ViewModels/Controls/ToolBarViewModel';
import Utilities from '@/Utility/Utilities';

export default class ToolBarLinkViewModel extends LinkViewModel {

    protected context: DetailViewContext;
    public toolBar: ToolBarViewModel;
    private showToolbarText: boolean;

    public constructor(protected params: IToolBarLinkViewModelConstructorParameter) {
        super(params);

        this.tooltip = this.createTooltipLabelViewModel();
        this.context = this.paramOrDefault(params.context, null);
        this.initShowToolbarText();
    }

    /**
     * Property wird bereits durch Aufruf in Oberklassen-Konstruktor benötigt
     */
    private initShowToolbarText(): void {
        if (!Utilities.isNullOrUndefined(this.showToolbarText))
            return;
        this.showToolbarText = this.paramOrDefault(this.params.showToolBarText, GlobalConfiguration.listView.ShowToolbarText);
    }

    protected createTooltipLabelViewModel(): LabelViewModel {
        return new LabelViewModelBuilder()
            .withErgName(this.params.tooltipErgName)
            .build();
    }

    protected createLabelViewModel(): LabelViewModel {
        this.initShowToolbarText();

        if (this.params.ergName === null)
            return null;

        return new LabelViewModelBuilder()
            .withErgName(this.params.ergName)
            .withIsVisible(this.showToolbarText)
            .build();
    }

    protected createImageViewModel(): ImageViewModel {
        return new ImageViewModelBuilder()
            .withSource(this.params.imageSource)
            .withAlternativeTextErgName(this.params.tooltipErgName)
            .build();
    }

    protected createWritableComputed<T>(defaultReadFunction: (...args) => T): KnockoutComputed<T> {
        const obs = this.observableOrDefault<T>(null);
        return this.defineComputed({
            read: () => {
                if (obs() != null)
                    return obs();

                return defaultReadFunction();
            },
            write: (value: T) => {
                obs(value);
            }
        });
    }
}

ComponentManager.setViewModel('ToolBarLink', ToolBarLinkViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');